import React, { useContext, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Formik, Field } from 'formik';
import { useMutation } from '@apollo/client';

import DataState from '../DataState';
import AuthContext from '../../contexts/AuthContext';
import { formatAuthErrors } from '../../utils/errorHelpers';

import { LOGIN } from './queries';
import { loginSchema } from './schemas';
import {
  Container,
  InnerContainer,
  Title,
  Label,
  Input,
  Button,
  ErrorMessage,
  Instructions,
  ActionLink,
} from './elements';

const Login = ({ setShowForgotPassword, noPortalUsers }) => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const {
    updateCredentials,
    rememberMe,
    updateRememberMe,
    loginAttempted,
    dataLoaded,
    clearCredentials
  } = useContext(AuthContext);

  const [login] = useMutation(LOGIN, {
    onCompleted: data => {
      updateCredentials(data.portalUserLogin.credentials);
    },
    onError: error => {
      setErrorMessage(formatAuthErrors(error.graphQLErrors));
      setFormSubmitting(false);
    }
  });

  const handleSubmit = values => {
    setFormSubmitting(true);

    const { rememberMeEnabled, ...submitValues } = values;
    updateRememberMe(rememberMeEnabled ? values.email : '');

    login({ variables: submitValues });
  };

  useEffect(() => {
    if(loginAttempted && dataLoaded && noPortalUsers) {
      if(formSubmitting) {
        setFormSubmitting(false);
      }
      if(errorMessage !== 'Credentials not valid for this portal.') {
        setErrorMessage('Credentials not valid for this portal.')
      }
      clearCredentials();
    }
  }, [loginAttempted, dataLoaded, noPortalUsers, formSubmitting, errorMessage]);

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Container>
        <InnerContainer>
          <Title>Login</Title>
          {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

          {formSubmitting || 'undefined' === typeof rememberMe ? (
            <DataState.Loading />
          ) : (
            <Formik
              initialValues={{
                email: (rememberMe || ''),
                password: '',
                rememberMeEnabled: !!rememberMe,
              }}
              validationSchema={loginSchema}
              onSubmit={handleSubmit}
            >
              {props => (
                <form onSubmit={props.handleSubmit}>
                  <Label>Company Email</Label>
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                  <Label>Password</Label>
                  <Input
                    type="password"
                    name="password"
                    placeholder="Password"
                  />

                  <Instructions style={{marginTop: 24, fontSize: '0.9rem'}}>
                    <label>
                      <Field
                        name="rememberMeEnabled"
                        type="checkbox"
                        style={{marginRight: 10}}
                      />
                      Remember Me
                    </label>

                    <ActionLink
                      href="#"
                      onClick={() => setShowForgotPassword(true)}
                      style={{marginLeft: '2rem'}}
                    >
                      Forgot Password?
                    </ActionLink>
                  </Instructions>

                  <Button type="submit">
                    Login
                  </Button>

                  <Instructions
                    style={{
                      textAlign: 'center',
                      marginTop: 24,
                      fontSize: '0.9rem'
                    }}
                  >
                    Don't have an account?
                    <ActionLink
                      href="mailto:fuel@flylouie.com"
                      style={{marginLeft: '0.3rem'}}
                    >
                      Contact Us
                    </ActionLink>
                  </Instructions>
                </form>
              )}
            </Formik>
          )}

          <Instructions style={{marginTop: 24, fontSize: '0.9rem'}}>
          </Instructions>
        </InnerContainer>
      </Container>
    </>
  )
}

export default Login;
